export default "__VITE_ASSET__C0ZHsA2S__"